import styled from 'styled-components';

const StyledB = styled.a`
  color: #000;
  font-family: inherit;
  text-decoration: none;
  cursor: pointer;
  font-size: 15px;
`;

export default StyledB;
